import { IconHome2, IconLayoutKanban, IconSpeakerphone, IconWorld } from '@tabler/icons-react';

export const VALID_STAGES = ['prospect', 'qualified', 'contacted', 'hot', 'booked', 'closed', 'lost'];

export const BOT_OPTIONS = [
  { value: 'Altum_Bot', label: 'Altum_Bot' },
  { value: 'Caro_Bot', label: 'Caro_Bot' },
  { value: 'Jax', label: 'Jax' },
  { value: 'driveoffshield_agent', label: 'driveoffshield_agent' },
];

export const NAV_SECTIONS = [
  { label: 'Home', href: '/home', icon: IconHome2 },
  { label: 'Pipeline', href: '/pipeline', icon: IconLayoutKanban },
  { label: 'Campaigns', href: '/campaigns', icon: IconSpeakerphone },
  { label: 'Hosted Pages', href: '/hosting', icon: IconWorld },
];

export const STAGE_CONFIG = [
  { id: 'prospect', label: 'Prospect', color: 'gray' },
  { id: 'qualified', label: 'Qualified', color: 'violet' },
  { id: 'contacted', label: 'Contacted', color: 'blue' },
  { id: 'hot', label: 'Hot', color: 'orange' },
  { id: 'booked', label: 'Booked', color: 'teal' },
  { id: 'closed', label: 'Closed Won', color: 'green' },
  { id: 'lost', label: 'Closed Lost', color: 'red' },
];
